var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHisPatientOld = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 42.2222,
    height: 41,
    rx: 11,
    fill: "#6664D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8889 16.1389V12.9444C23.8889 11.3887 23.8889 10.6109 23.5861 10.0167C23.3198 9.49401 22.8948 9.06907 22.3722 8.80276C21.778 8.5 21.0001 8.5 19.4444 8.5H14.4444C12.8887 8.5 12.1109 8.5 11.5167 8.80276C10.994 9.06907 10.5691 9.49401 10.3028 10.0167C10 10.6109 10 11.3887 10 12.9444V29.0556C10 30.6112 10 31.3892 10.3028 31.9833C10.5691 32.506 10.994 32.931 11.5167 33.1972C12.1109 33.5 12.8887 33.5 14.4444 33.5H17.6389M10 22.3889H16.9444M10 27.9444H16.9444M19.7222 15.4445L14.1667 15.4444M16.9444 12.6667V18.2222M29.7222 23.0833C29.7222 24.2339 28.7894 25.1667 27.6389 25.1667C26.4883 25.1667 25.5555 24.2339 25.5555 23.0833C25.5555 21.9328 26.4883 21 27.6389 21C28.7894 21 29.7222 21.9328 29.7222 23.0833ZM32.2222 33.5V32.8056C32.2222 30.8879 30.6676 29.3333 28.75 29.3333H26.6667C24.749 29.3333 23.1944 30.8879 23.1944 32.8056V33.5H32.2222Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHisPatientOld, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HIS-patient-old.af7b3608.svg";
export { ForwardRef as ReactComponent };